<template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col cols="12" class="text-center">
        <h1>Results</h1>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-select
            :items="items"
            v-model="select"
            label="Select Days"
        ></v-select>

      </v-col>
      <v-col cols="12">
        <v-simple-table>
          <template v-slot:default>
            <v-lazy
                v-model="isActive"
                :options="{
              threshold: .5
              }"
                transition=""
            >
              <template>
                <thead>
                <tr>
                  <th class="text-left">
                    {{ $t('name-and-info') }}
                  </th>
                  <th class="text-left">
                    {{ $t('under_review') }}
                  </th>
                  <span v-if="select == 'all' || select == 'day1'">
                    <th class="text-left, bg1">
                      {{ $t('day') }}
                    </th>
                    <th class="text-left, bg1">
                      {{ $t('distance') }}
                    </th>
                    <th class="text-left, bg1">
                      {{ $t('time') }}
                    </th>
                    <th class="text-left, bg1">
                      {{ $t('kmh') }}
                    </th>
                    <th class="text-left, bg1">
                      {{ $t('proof-image') }}
                    </th>
                    <th class="text-left, bg1">
                      {{ $t('proof-image-1') }}
                    </th>
                    <th class="text-left, bg1">
                      {{ $t('proof-image-2') }}
                    </th>
                    <th class="text-left, bg1">
                      {{ $t('approve') }}
                    </th>
                  </span>
                  <span v-if="select == 'all' || select == 'day2'">
                    <th class="text-left, bg2">
                      {{ $t('day') }}
                    </th>
                    <th class="text-left, bg2">
                      {{ $t('distance') }}
                    </th>
                    <th class="text-left, bg2">
                      {{ $t('time') }}
                    </th>
                    <th class="text-left, bg2">
                      {{ $t('kmh') }}
                    </th>
                    <th class="text-left, bg2">
                      {{ $t('proof-image') }}
                    </th>
                    <th class="text-left, bg2">
                      {{ $t('proof-image-1') }}
                    </th>
                    <th class="text-left, bg2">
                      {{ $t('proof-image-2') }}
                    </th>
                    <th class="text-left, bg2">
                      {{ $t('approve') }}
                    </th>
                  </span>
                  <span v-if="select == 'all' || select == 'day3'">
                    <th class="text-left, bg3">
                      {{ $t('day') }}
                    </th>
                    <th class="text-left, bg3">
                      {{ $t('distance') }}
                    </th>
                    <th class="text-left, bg3">
                      {{ $t('time') }}
                    </th>
                    <th class="text-left, bg3">
                      {{ $t('kmh') }}
                    </th>
                    <th class="text-left, bg3">
                      {{ $t('proof-image') }}
                    </th>
                    <th class="text-left, bg3">
                      {{ $t('proof-image-1') }}
                    </th>
                    <th class="text-left, bg3">
                      {{ $t('proof-image-2') }}
                    </th>
                    <th class="text-left, bg3">
                      {{ $t('approve') }}
                    </th>
                  </span>
                  <span v-if="select == 'all' || select == 'day4'">
                    <th class="text-left, bg4">
                      {{ $t('day') }}
                    </th>
                    <th class="text-left, bg4">
                      {{ $t('distance') }}
                    </th>
                    <th class="text-left, bg4">
                      {{ $t('time') }}
                    </th>
                    <th class="text-left, bg4">
                      {{ $t('kmh') }}
                    </th>
                    <th class="text-left, bg4">
                      {{ $t('proof-image') }}
                    </th>
                    <th class="text-left, bg4">
                      {{ $t('proof-image-1') }}
                    </th>
                    <th class="text-left, bg4">
                      {{ $t('proof-image-2') }}
                    </th>
                    <th class="text-left, bg4">
                      {{ $t('approve') }}
                    </th>
                  </span>
                </tr>

                </thead>
                <tbody>
                <tr
                    v-for="item in results"
                    :key="item.name"
                >
                  <td v-if="item.user.nick_name && item.user.nick_name !== ''">{{ item.user.first_name }}, {{ item.user.last_name }} {{ item.user.nick_name }} {{ item.user.march_id }} {{ item.user.email }},</td>
                  <td v-else>{{ item.user.first_name }}, {{ item.user.last_name }} {{ $t('no-nickname') }} {{ item.user.march_id }} {{ item.user.email }} </td>
                  <td>
                    <v-checkbox
                      v-model="item.under_review"
                    ></v-checkbox>
                  </td>
                  <span v-if="select == 'all' || (select == 'day1' && item.accepted_1 == false)">
                    <span>
                      <td class="bg1">{{ item.day_1 }}</td>
                      <td class="bg1">{{ item.distance_1 }}</td>
                      <td class="bg1">{{ item.time_1 }}</td>
                      <td class="bg1">{{ item.kmh_1 }}</td>
                      <td>
                        <enlargeable-image :src="base_url+ item.image_path_1_1"
                                          :src_large="base_url+ item.image_path_1_1"
                                          max-height="150px" max-width="150px"/>
                      </td>
                      <td>
                        <enlargeable-image :src="base_url+ item.image_path_1_2"
                                          :src_large="base_url+ item.image_path_1_2"
                                          max-height="150px" max-width="150px"/>
                      </td>
                      <td>
                        <enlargeable-image :src="base_url+ item.image_path_1_3"
                                          :src_large="base_url+ item.image_path_1_3"
                                          max-height="150px" max-width="150px"/>
                      </td>
                      <td class="bg1">
                        <v-checkbox
                            :disabled="item.disable_checkbox_1"
                            v-model="item.accepted_1"
                        ></v-checkbox>
                      </td>
                    </span>
                  </span>
                  
                  <span v-if="select == 'all' || (select == 'day2' && item.accepted_2 == false)">

                  <td class="bg2">{{ item.day_2 }}</td>
                  <td class="bg2">{{ item.distance_2 }}</td>
                  <td class="bg2">{{ item.time_2 }}</td>
                  <td class="bg2">{{ item.kmh_2 }}</td>
                  <td>
                    <enlargeable-image :src="base_url+ item.image_path_2_1"
                                       :src_large="base_url+ item.image_path_2_1"
                                       max-height="150px" max-width="150px"/>
                  </td>
                  <td>
                    <enlargeable-image :src="base_url+ item.image_path_2_2"
                                       :src_large="base_url+ item.image_path_2_2"
                                       max-height="150px" max-width="150px"/>
                  </td>
                  <td>
                    <enlargeable-image :src="base_url+ item.image_path_2_3"
                                       :src_large="base_url+ item.image_path_2_3"
                                       max-height="150px" max-width="150px"/>
                  </td>
                  <td class="bg2">
                    <v-checkbox
                        :disabled="item.disable_checkbox_2"
                        v-model="item.accepted_2"
                    ></v-checkbox>
                  </td>
                  </span>
                  <span v-if="select == 'all' || (select == 'day3' && item.accepted_3 == false)">
                  <td class="bg3">{{ item.day_3 }}</td>
                  <td class="bg3">{{ item.distance_3 }}</td>
                  <td class="bg3">{{ item.time_3 }}</td>
                  <td class="bg3">{{ item.kmh_3 }}</td>
                  <td>
                    <enlargeable-image :src="base_url+ item.image_path_3_1"
                                       :src_large="base_url+ item.image_path_3_1"
                                       max-height="150px" max-width="150px"/>

                  </td>
                  <td>
                    <enlargeable-image :src="base_url+ item.image_path_3_2"
                                       :src_large="base_url+ item.image_path_3_2"
                                       max-height="150px" max-width="150px"/>
                  </td>
                  <td>
                    <enlargeable-image :src="base_url+ item.image_path_3_3"
                                       :src_large="base_url+ item.image_path_3_3"
                                       max-height="150px" max-width="150px"/>

                  </td>
                  <td class="bg3">
                    <v-checkbox
                        :disabled="item.disable_checkbox_3"
                        v-model="item.accepted_3"
                    ></v-checkbox>
                  </td>
                  </span>
                  <span v-if="select == 'all' || (select == 'day4' && item.accepted_4 == false)">

                  <td class="bg4">{{ item.day_4 }}</td>
                  <td class="bg4">{{ item.distance_4 }}</td>
                  <td class="bg4">{{ item.time_4 }}</td>
                  <td class="bg4">{{ item.kmh_4 }}</td>
                  <td>
                    <enlargeable-image :src="base_url+ item.image_path_4_1"
                                       :src_large="base_url+ item.image_path_4_1"
                                       max-height="150px" max-width="150px"/>
                  </td>
                  <td>
                    <enlargeable-image :src="base_url+ item.image_path_4_2"
                                       :src_large="base_url+ item.image_path_4_2"
                                       max-height="150px" max-width="150px"/>
                  </td>
                  <td>
                    <enlargeable-image :src="base_url+ item.image_path_4_3"
                                       :src_large="base_url+ item.image_path_4_3"
                                       max-height="150px" max-width="150px"/>
                  </td>
                  <td class="bg4">
                    <v-checkbox
                        :disabled="item.disable_checkbox_4"
                        v-model="item.accepted_4"
                    ></v-checkbox>
                  </td>
                  </span>
                </tr>
                </tbody>
              </template>
            </v-lazy>
          </template>
        </v-simple-table>
      </v-col>
      <v-col cols="12">
        <v-btn color="primary" @click.stop="save()">{{
            $t("save")
          }}
        </v-btn>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Axios from '@/api/apiconfig'
import EnlargeableImage from '@diracleo/vue-enlargeable-image';

export default {
  name: "CompetitionAdminUnapproved",
  components: {EnlargeableImage},

  data: () => ({
    results: [], //
    items: ['all', "day1", "day2", "day3", "day4"],
    select: "all",
    base_url: 'https://api.resulfourdaymarch.fi/v1.0/competition/'
  }),
  methods: {
    getResults() {
      Axios.get('/competition/unapproved_results', {withCredentials: true}).then(data => {
        if (data) {
          this.results = data.data.data.competition

          for (let i = 0; i < this.results.length; i++) {
            let result = this.results[i]
            console.log(result)

            if (result.distance_1) {
              result.distance_1 = result.distance_1.toFixed(1)
              result.kmh_1 = this.calculateAverageSpeed(result.distance_1, result.time_1)
              result.time_1 = this.removeSeconds(result.time_1)
            } else {
              result.disable_checkbox_1 = true
            }
            if (result.distance_2) {
              result.distance_2 = result.distance_2.toFixed(1)
              result.kmh_2 = this.calculateAverageSpeed(result.distance_2, result.time_2)
              result.time_2 = this.removeSeconds(result.time_2)
            } else {
              result.disable_checkbox_2 = true
            }
            if (result.distance_3) {
              result.distance_3 = result.distance_3.toFixed(1)
              result.kmh_3 = this.calculateAverageSpeed(result.distance_3, result.time_3)
              result.time_3 = this.removeSeconds(result.time_3)
            } else {
              result.disable_checkbox_3 = true
            }
            if (result.distance_4) {
              result.distance_4 = result.distance_4.toFixed(1)
              result.kmh_4 = this.calculateAverageSpeed(result.distance_4, result.time_4)
              result.time_4 = this.removeSeconds(result.time_4)
            } else {
              result.disable_checkbox_4 = true
            }
          }
        }
      })
    },
    save() {
      Axios.post('/competition/approve_results', this.results, {withCredentials: true}).then(data => {

      });
    },
    calculateAverageSpeed(distance, time) {
      if(distance != null && time != null) {
          let minutes = this.timeToMins(time)
          let hours = minutes / 60
          let kmh = distance / hours;
          let kmhRounded = Math.round(kmh * 100) / 100

          return kmhRounded;
        } else {
            return 0;
        }
    },
    removeSeconds(time) {
        if(time != null) {
          const words = time.split(":");
          let shortened = words[0].concat(":", words[1]);
          return shortened
        }
    },
    timeToMins(time){
      var b = time.split(':');
      return b[0]*60 + +b[1];
    },
    timeFromMins (mins){
      function z(n){return (n<10? '0':'') + n;}
      var h = (mins/60 |0);
      var m = mins % 60;
      return z(h) + ':' + z(m);
    },
    formatNumber (value, no){
      if(value == null){
        return "-"
      } else {
        return value.toFixed(no)
      }
    },
  },
  mounted() {
    this.getResults()
  }
}
</script>

<style scoped>
.bg1 {
  background-color: lightgray;
}

.bg2 {
  background-color: lightcoral;
}

.bg3 {
  background-color: lightgreen;
}

.bg4 {
  background-color: lightblue;
}

.text-left {
  padding-right: 5px;
}
span {
  display: contents;
}
</style>